const root = document.documentElement;
const prefersColorScheme = window.matchMedia("(prefers-color-scheme: dark)");

let usingOSPreference = localStorage.getItem("darkMode") === null;

function setColorMode(isDark, savePreference = true) {
  root.classList.toggle("u-mode-invert", isDark);

  const checkbox = document.getElementById("color-mode");
  if (checkbox) {
    checkbox.checked = isDark;
  }

  if (savePreference) {
    localStorage.setItem("darkMode", isDark ? "true" : "false");
  }
}

function initColorMode() {
  const savedMode = localStorage.getItem("darkMode");
  const initialDarkMode = savedMode === null ? prefersColorScheme.matches : savedMode === "true";

  setColorMode(initialDarkMode, savedMode !== null);

  const checkbox = document.getElementById("color-mode");
  if (checkbox) {
    checkbox.addEventListener("change", () => {
      usingOSPreference = false;
      setColorMode(checkbox.checked, true);
    });
  }

  const toggleLabel = document.querySelector(".toggle-label");
  if (toggleLabel) {
    window.setTimeout(() => {
      toggleLabel.classList.add("has-transition");
    }, 100);
  }

  prefersColorScheme.addEventListener("change", (event) => {
    if (usingOSPreference) {
      setColorMode(event.matches, false);
    }
  });
}

function initExpandableIntro() {
  const trigger = document.querySelector("[data-more-toggle]");
  if (!trigger) {
    return;
  }

  const targetId = trigger.getAttribute("data-more-toggle");
  const target = targetId ? document.getElementById(targetId) : null;
  const ellipsis = document.querySelector("[data-more-ellipsis]");

  if (!target) {
    return;
  }

  trigger.addEventListener("click", () => {
    const willExpand = target.hasAttribute("hidden");
    target.toggleAttribute("hidden");
    trigger.setAttribute("aria-expanded", String(willExpand));
    trigger.textContent = willExpand ? "Less" : "More";
    if (ellipsis) {
      ellipsis.classList.toggle("is-hidden", willExpand);
    }
  });
}

initColorMode();
initExpandableIntro();
